import { t } from "@travily/i18n";
import { WizardTextArea } from "@ui/components/WizardTextArea";
import type { ListingFieldCopy, ListingFieldProps, ListingType } from "./types";

const COLOR = "green" as const;
const MAX_LENGTH = 160;

// i18n-tasks-use t('web.listings.fields.tagline.product.heading')
// i18n-tasks-use t('web.listings.fields.tagline.product.helper')
// i18n-tasks-use t('web.listings.fields.tagline.product.placeholder')
// i18n-tasks-use t('web.listings.fields.tagline.service.heading')
// i18n-tasks-use t('web.listings.fields.tagline.service.helper')
// i18n-tasks-use t('web.listings.fields.tagline.service.placeholder')

export function taglineFieldCopy(listingType: ListingType): ListingFieldCopy {
  return {
    heading: t(`web.listings.fields.tagline.${listingType}.heading`),
    helper: t(`web.listings.fields.tagline.${listingType}.helper`),
  };
}

export function TaglineField({ error, listingType, onBlur, onChange, onKeyDown, value }: ListingFieldProps) {
  const { heading } = taglineFieldCopy(listingType);

  return (
    <WizardTextArea
      aria-label={heading}
      autoFocus
      autoGrow
      color={COLOR}
      errorMessage={error}
      isInvalid={Boolean(error)}
      isLabelHidden
      label={heading}
      maxLength={MAX_LENGTH}
      onBlur={onBlur}
      onChange={onChange}
      // Enter advances the wizard; the server normalizes the tagline to one line, so a stray
      // newline (pasted, or in an existing value) is collapsed on save rather than guarded here.
      onKeyDown={onKeyDown}
      placeholder={t(`web.listings.fields.tagline.${listingType}.placeholder`)}
      showCharacterCount
      // Height floor for the auto-growing field: 4 lines on mobile where the 160-char cap wraps
      // further, 3 on ≥sm.
      textAreaClassName="min-h-[9rem] sm:min-h-[7.5rem]"
      value={value}
    />
  );
}
